import { getIndexByEntityId, getLowerCaseSelector, toCSV } from 'utils/clickme';
import { VIEW_DATE_FORMAT, VIEW_DATE_WITH_TIME_FORMAT } from 'utils/constants/date';
import { formatDate } from 'utils/date';

import { InvoiceDreamPayerType } from 'store/models/invoices';

export default (from, to, filterType, filterValue, invoices, accounts, trl) => {
    const fileName = `invoices_${formatDate(from, VIEW_DATE_FORMAT)}-${formatDate(to, VIEW_DATE_FORMAT)}${
        filterValue && `_${filterType}=${filterValue}`
    }.csv`;

    const invoicesForCSV = invoices.map(
        ({
            createdAt,
            accountId,
            title,
            payerType,
            address,
            post,
            inn,
            kpp,
            userId,
            number,
            amount,
            promoBonus,
            status,
            userName,
        }) => {
            let payer = title;
            switch (payerType) {
                case InvoiceDreamPayerType.Individual:
                    payer += ` (${address}, ${post}, ${inn})`;
                    break;
                case InvoiceDreamPayerType.Legal:
                    payer += `${title} (${address}, ${post}, ${inn}, ${kpp})`;
                    break;
            }

            return {
                createdAt: formatDate(createdAt, VIEW_DATE_WITH_TIME_FORMAT),
                employerId: accounts[getIndexByEntityId(accountId, accounts, 'id')].employerId,
                accountId,
                number:
                    payerType === InvoiceDreamPayerType.HH
                        ? trl('admin.Invoices.InvoicesTable.Invoice.HH')
                        : `${trl('admin.Invoices.InvoicesTable.Invoice.number')}/${userId}/${number}`,
                amount,
                promoBonus,
                status: trl(`InvoiceStatus.${getLowerCaseSelector(status)}`),
                userId,
                userName,
                payer,
            };
        }
    );

    const headers = [
        'createdAt',
        'employerId',
        'accountId',
        'number',
        'amount',
        'promoBonus',
        'status',
        'userId',
        'userName',
        'payer',
    ];

    toCSV(fileName, invoicesForCSV, headers, []);
};
